<template>
  <notes-filter
    @filters-updated="$emit('filters-updated')"
  >
    <div
      v-if="Object.keys(metadata).length"
      slot-scope="{remove, metadata}"
      class="u-px2 u-mt2 l-flex-grid"
    >
      <template v-for="(item, key) in metadata">
        <el-tag
          @close="remove({[key]:item})"
          class="u-mb2 u-mr2"
          closable
          :key="key"
          :data-element="`close-${dasherized(item.label)}-filter-tag`"
        >
          <strong>{{item.label}}:</strong>
          {{item.value}}
        </el-tag>
      </template>
    </div>
  </notes-filter>
</template>

<script>
import NotesFilter from '#/notes/components/NotesFilter'

export default {
  name: 'NotesFilterTagList',
  components: {
    NotesFilter
  },
  methods: {
    dasherized (value) {
      return value.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
</script>
